import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';

import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';

import { SegmentTrackMenu } from '@unico-people/shared/enums/utils-enums';
import { environment } from '@unico-people/shared/utils/environments';
import { DataAccessFeatureFlagService } from '@unico-people/shared/data-access/data-access-feature-flag';
import { LaunchdarklyService } from '@acesso-io/launchdarkly-client-ts/lib/launchdarkly';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Component({
  selector: 'up-feature-sidebar-account',
  templateUrl: './feature-sidebar-account.component.html',
  styleUrls: ['./feature-sidebar-account.component.scss']
})
export class FeatureSidebarAccountComponent implements OnInit {
  private readonly signUrl: string = environment.sign_url;
  private readonly account = SessionStorage.getItem('currentAccountName');
  private readonly organization = SessionStorage.getItem('organizationName');
  public readonly baseUrl: string = environment.admission_url;
  public readonly collaboratorUrl: string = environment.ongoing_url;
  showBenefitsProductivity = false;

  @Input()
  set openMenu(open: boolean) {
    this.showMenu = open;
  }
  @Output() menu = new EventEmitter<boolean>();
  @Output() load = new EventEmitter<boolean>();

  adminUrl = SessionStorage.getItem('currentAccount') ? `${this.baseUrl}?a=${SessionStorage.getItem('currentAccount')}` : `${this.baseUrl}`;
  singUrl = `${this.signUrl}/login-integration?product_id=99c3dfc5-7518-4d7c-9e75-e54d920721fd&redirect_uri=${this.baseUrl}`;
  url: string = environment.cdn_url;
  list: any;
  query: any;
  acc: any;
  showMenu = false;
  company = false;
  reports = false;
  hasReportsPermission = false;
  hasCollaborators = true;
  hasSignature = false;
  flagActiveModelsListModule = false;
  enableNewModelsList = false;

  constructor(
    public router: Router,
    private store: Store<fromStore.DashboardState>,
    private segment: TrackingSegmentService,
    private featureFlagService: DataAccessFeatureFlagService,
    private launchDarklyService: LaunchdarklyService,
    ) {}

  ngOnInit(): void {
    this.verifyLaunchDarklyFlag();
    this.store.pipe(select(fromStore.getOrganizationState)).subscribe(res => {
      this.list = res?.groups;
      this.acc = res?.currentAccount;
    });

    this.store.pipe(select(fromStore.getModulesEntities)).subscribe(res => {
      this.hasCollaborators = res?.collaborators;
      this.hasSignature = res?.signature;
    });
    this.checkFlag(
      "people-rh_test_productivity",
      "6ffff7c5-58a5-4331-97b6-3c905d6e812a"
    );
  }

  verifyLaunchDarklyFlag(): void {
    this.checkLaunchDarklyFlag('people-rh-new-settings-models-list').then((response: boolean) => {
      this.flagActiveModelsListModule = response;
    });

    this.checkLaunchDarklyFlag('people-rh-new-settings-models-list').then((response: boolean) => {
      this.enableNewModelsList = response;
    });
  }

  private async checkLaunchDarklyFlag(flag: string): Promise<boolean> {
    const ctx = {
      kind: 'user',
      key: SessionStorage.getItem('organization')
    };
    await this.launchDarklyService?.overrideContext({ context: ctx });
    return this.launchDarklyService?.evaluateBoolean({ flagKey:flag});
  }

  checkFlag(key: string, id: string ): void {
    this.featureFlagService.hasFlag({
      flag_key: key,
      entity_id: id,
      context: {
        organization_id: SessionStorage.getItem('organization')
      }
    }).subscribe(flag => {
      if (flag?.match === true) {
        this.showBenefitsProductivity = true;
      }
    })
  }

  toggleMenu(target?: string): void {
    this.showMenu = !this.showMenu;
    this.company = false;
    this.reports = false;
    this.menu.emit(this.showMenu);

    const segmentTrack = {
      candidate: SegmentTrackMenu.click_menu_candidates,
      listing: SegmentTrackMenu.click_menu_listing,
      import: SegmentTrackMenu.click_menu_import,
      history: SegmentTrackMenu.click_menu_history
    }

    this.segment.track(segmentTrack[target])
  }

  changeCompany(uid: string): void {
    const companies = this.list.reduce((all, item) => {
      item.accounts.map(res => {
        all.push(res);
      });
      return all;
    }, []);
    const account = companies.filter(x => x.uid === uid)[0];
    this.store.dispatch(fromStore.changeAccount({ payload: account }));
    if (account?.name) {
      SessionStorage.setItem('currentAccountName', account.name);
    }
    SessionStorage.setItem('currentAccount', uid);
    this.router.navigate(['/']);
    location.reload();
  }

  toggleTab() {
    this.company = !this.company;
    this.reports = false;
  }
}
